import React from 'react'

import { TableCell } from '@mui/material'
import { TimeUtils, UserUtils } from '@front/volcanion/utils'
import { TextCell } from '@abra/elements/table/cells/basics'
import { OrderLink } from '@abra/elements'

import moment from 'moment'

const HistoryRow = ({ row }) => {
  const requestedAt = moment.utc(TimeUtils.getDetailsMomentFront(row?.requestedAt, row?.source)).local().format('DD/MM/YYYY HH:mm')
  const formula_name = row?.service?.contract?.formula?.name || row?.do?.commercial_formula?.name
  return <>
    <TableCell size='small' padding='none'>
      <TextCell fontSize={13} value={row?.voucher?.code} />
    </TableCell>
    <TableCell size='small' padding='none'>
      <OrderLink record_id={row?.order_id} fontSize={13} />
    </TableCell>
    <TableCell size='small' padding='none'>
      <TextCell fontSize={13} value={requestedAt} />
    </TableCell>
    <TableCell size='small' padding='none'>
      <TextCell fontSize={13} value={formula_name} />
    </TableCell>
    <TableCell size='small' padding='none'>
      <TextCell fontSize={13} value={_.join(_.compact([row?.service?.name, UserUtils.getDisplayName(row?.do)]), ' / ')} />
    </TableCell>
  </>
}

export default React.memo(HistoryRow)
